import { appSchema, tableSchema } from '@nozbe/watermelondb';

export default appSchema({
  version: 1,
  tables: [
    tableSchema({
      name: 'books',
      columns: [
        { name: 'title', type: 'string' },
        { name: 'description', type: 'string' },
        { name: 'publisher', type: 'string', isOptional: true },
        { name: 'cover_url', type: 'string', isOptional: true },
        { name: 'translator', type: 'string', isOptional: true },
        { name: 'language', type: 'string' },
        { name: 'pagesCount', type: 'number' },
        { name: 'score', type: 'number' },
        { name: 'scoreCount', type: 'number' },
        { name: 'is_bookmarked', type: 'boolean', isIndexed: true },
        { name: 'type', type: 'number' },
        { name: 'status', type: 'number' },
        { name: 'categories', type: 'string' },
        { name: 'labels', type: 'string' },
        { name: 'is_downloaded', type: 'boolean', isIndexed: true },
      ],
    }),
    tableSchema({
      name: 'pages',
      columns: [
        { name: 'audio', type: 'string', isOptional: true },
        { name: 'containedEntities', type: 'string' },
        { name: 'text', type: 'string', isOptional: true },
        { name: 'topic', type: 'string', isOptional: true },
        { name: 'order', type: 'number', isIndexed: true },
        { name: 'is_downloaded', type: 'boolean', isIndexed: true },
        { name: 'book_id', type: 'string', isIndexed: true },
      ],
    }),
  ],
});
